// src/components/propertycard/PropertyCard.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import '../../../assets/css/Buyer/Home/featureProperty/propertycard.css';
import PropertyDetail from '../../../screens/Buyer/home/featureProperty/PropertyDetails';

const PropertyCards = ({ property,baseUrlForFiles }) => {
  const navigate = useNavigate();
  const [isDetailOpen, setIsDetailOpen]=useState(false);
  const handleDetailClick = () => {
    setIsDetailOpen(prev => !prev);
  };
  useEffect(() => {
      document.body.style.overflow = isDetailOpen ? "hidden" : "auto";
    }, [isDetailOpen]);


  const [isHovered, setIsHovered] = useState(false);

 {/* const handleDetailClick = (e) => {
    e.stopPropagation();
    navigate(`/property/${property.id}`);
  };
*/}
  // Filter toggle handler
  
  return (
    <>
    
    <div
      className="home-property-card-modern"
      
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      
      {/* Property Image with Overlay Content */}
      <div className="home-property-card-image-wrapper">
        <img 
          src={`${baseUrlForFiles}${property?.expropertyimages[0]?.images}`}  
          alt={property.property_title}
          className="home-property-image"
          loading="lazy"
        />
        
        {/* Gradient Overlay */}
        <div className={`home-property-image-overlay ${isHovered ? 'overlay-hover' : ''}`} />

        {/* Default View - Show on normal state */}
        {!isHovered && (
          <>
            {/* Badge Number - Bottom Left */}
            <div className="home-property-badge-number">
              {property.badge}
            </div>

            {/* Location Tag - Top Left */}
            <div className="home-property-location-badge">
              <FaMapMarkerAlt className="home-location-icon" />
              <span>{property.location}</span>
            </div>

            {/* Detail Button - Top Right */}
            <div className={`home-property-detail ${isDetailOpen ? 'property-dtail-open' : ''}`}>
              
            {/* <button 
              className="home-property-detail-icon"
              onClick={handleDetailClick}
              aria-label="View property details"
            >
              <FaArrowRight />
            </button> */}
            </div>
            

            {/* Property Title Overlay - Bottom Center */}
            <div className="home-property-title-overlay">
              <h3 className="home-property-main-title">{property.property_title}</h3>
              {/* <p className="home-property-sub-title">{property.subtitle}</p> */}
            </div>
          </>
        )}

        {/* Hover View - Top Header + Main Image Below */}
        {isHovered && (
          <>
            {/* Top White Header Section */}
            <div className="home-property-hover-header">
              {/* Row 1: Badge + Location + Type + Price */}
              <div className="home-hover-header-row">
                <div className="home-hover-badge-num">{property.badge}</div>
                
                <span className="home-hover-location">
                  <FaMapMarkerAlt /> {property.location}
                </span>
                
                <span className="home-hover-type">{property.property_type}</span>
                
                <div className="home-hover-price">{property.price}</div>
              </div>

              {/* Divider Line */}
              <div className="home-hover-divider"></div>

              {/* Row 2: Developer + Title + View Details Button */}
              <div className="home-hover-info-row">
                <div className="home-hover-left-info">
                  <p className="home-hover-developer">Developer: LuxeLine Properties</p>
                  <h3 className="home-hover-title">{property.property_title}</h3>
                </div>
              
                <button 
                  className="home-hover-view-btn"
                  onClick={handleDetailClick}
                >
                  View<br />Details
                </button>
                
         
              </div>
              
            </div>
            

            {/* Main Image Visible Below Header */}
            {/* Image is already visible in background */}
           
          </>
          
        )}
          
          {isDetailOpen && (
          <div 
             className="home-detail-backdrop"
             onClick={handleDetailClick}
             aria-hidden="true"
          />
         )}
        
      </div>
      
    </div>
    <PropertyDetail
            isOpen={isDetailOpen} 
            onClose={handleDetailClick}
            property={property}
            baseUrlForFiles={baseUrlForFiles}
          />
    </>
  );
};

export default PropertyCards;